import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { HomeIcon, ArrowLeft, Sparkles } from "lucide-react";

export default function UnderConstruction({ title = "Página em construção" }) {
  const navigate = useNavigate();
  return (
    <section data-testid="under-construction" className="min-h-[70vh] flex items-center justify-center px-6 py-24 bg-[color:var(--marupiara-ivory)]">
      <div className="max-w-2xl text-center">
        <div className="inline-flex items-center gap-2 overline text-[color:var(--marupiara-gold-dark)] mb-6">
          <Sparkles size={14} /> Em preparação
        </div>
        <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl text-[color:var(--marupiara-obsidian)] mb-6 leading-tight">
          {title}
        </h1>
        <p className="text-lg text-[color:var(--marupiara-text-on-light-muted)] max-w-xl mx-auto mb-10">
          Tudo bem, esta página ainda está sendo preparada. Em breve teremos novidades para você.
        </p>
        <div className="flex flex-wrap gap-4 justify-center">
          <button data-testid="under-construction-back" onClick={() => navigate(-1)} className="btn-outline-gold text-sm">
            <ArrowLeft size={14} /> Voltar
          </button>
          <Link to="/" data-testid="under-construction-home" className="btn-gold text-sm">
            <HomeIcon size={14} /> Home
          </Link>
        </div>
      </div>
    </section>
  );
}
